import { createSelector } from 'reselect';

export const selectLocale = (state) => state.locale;

export const getLocaleSelector = createSelector(
  selectLocale,
  (locale) => locale
);
